import { firestore } from '@utils/firebase'
import { ApiResponse } from '@Interfaces/Api/ResponsesInterface'
import { Cause } from '@Interfaces/Data/CauseInterface'

export const getCauses = async (): Promise<ApiResponse<Cause[]>> => {
  try {
    const querySnapshot = await firestore.collection('causes').orderBy('lowercaseName', 'asc').get()

    const causes: Cause[] = querySnapshot.docs.map(
      (doc) =>
        ({
          id: doc.id,
          ...doc.data(),
        }) as Cause
    )

    return { success: true, data: causes }
  } catch (error: any) {
    return {
      success: false,
      error: error?.message || 'Failed to fetch causes',
      data: undefined,
    }
  }
}

export const getOurCauses = (causeIds: string[], allCauses: Cause[]): Cause[] => {
  if (!causeIds || !Array.isArray(causeIds) || causeIds.length === 0) {
    return []
  }

  if (!allCauses || !Array.isArray(allCauses)) {
    return []
  }

  return allCauses.filter((cause) => causeIds.includes(cause.id))
}
